import React, { useState, useEffect } from "react";
import { IbsTable } from "../../components/Tables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faLock } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Card, Alert } from "react-bootstrap";
import LoadingComponent from "../../components/LoadingComponent";
import "./PermissionsAndReports.scss";

function PermissionsAndReportPage (props) {
    const [selectedIb, setSelectedIb] = useState(null);
    const [isIbDataLoading, setIsIbDataLoading] = useState(false);
    const [wasSearched, setWasSearched] = useState(false);

    const searchWasMade = (queried) => {
        setWasSearched(queried);
      };

    const deselectAllOtherRows = (row) => {
    if (
        row !== null &&
        row !== undefined &&
        selectedIb !== null &&
        wasSearched === false
    ) {
        return row.ib_number !== selectedIb.ib_number;
    } else {
        return false;
    }
    };

    useEffect(() => {
        if (selectedIb !== null && selectedIb?.selectedRows?.length > 0) {
            setSelectedIb(selectedIb?.selectedRows[0]);
          } else if (
            selectedIb !== null &&
            (selectedIb?.selectedRows?.length === 0 ||
              selectedIb.ib_number === undefined)
          ) {
            setSelectedIb(null);
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIb])
    return (
        <>
            <Row
                className="justify-content-md-center"
                style={{ paddingRight: "2vw", marginTop: "2vw" }}
            >
            <Col xs={12} className="mb-4 d-none d-sm-block">
                <IbsTable type="all"
                actions={[
                    {
                    type: "search",
                    },
                ]}
                selectedCallback={setSelectedIb}
                didSearch={searchWasMade}
                deselectedCallback={deselectAllOtherRows}
                deactivateAll
                onlyUsers={true}
                />
                    </Col>
            </Row>
            <Row
                className="justify-content-md-center"
                style={{ paddingRight: "2vw", marginTop: "2vw" }}
            >
                <Col xs={12} className="mb-4 d-none d-sm-block">
                    <Card border="light" className="shadow-sm">
                    {isIbDataLoading && (
                            <>
                                <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                            </>
                    )}
                     <Card.Header style={{ marginBottom: "20px" }}>
                            <Row>
                            {(selectedIb === null ||
                                (selectedIb !== null &&
                                selectedIb?.selectedRows?.length === 0) ||
                                (selectedIb !== null &&
                                selectedIb.ib_number === undefined)) && (
                                <>
                                <Col className="text-center text-md-center">
                                    <Alert variant={"info"} style={{ margin: "15px" }}>
                                    Selecciona un Afiliado Comercial para{" "}
                                    <b>
                                        cambiar sus permisos
                                    </b>
                                    </Alert>
                                </Col>
                                </>
                            )}
                            {(selectedIb !== null ||
                                (selectedIb !== null &&
                                selectedIb?.selectedRows?.length > 0) ||
                                (selectedIb !== null &&
                                selectedIb.ib_number !== undefined)) && (
                                <>
                                <Col className="text-center">
                                    <h4>
                                    {" "}
                                    <b>
                                        Permisos Afiliado Comercial{" "}
                                        <FontAwesomeIcon icon={faLock} />
                                    </b>
                                    </h4>
                                </Col>
                                </>
                            )}
                            </Row>
                        </Card.Header>
                    </Card>
                </Col>

            </Row>
            <Row
                className="justify-content-md-center"
                style={{ paddingRight: "2vw", marginTop: "2vw" }}
            >
                <Col xs={12} className="mb-4 d-none d-sm-block">
                    <Card border="light" className="shadow-sm">
                    {isIbDataLoading && (
                            <>
                                <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                            </>
                    )}
                     <Card.Header style={{ marginBottom: "20px" }}>
                            <Row>
                            {(selectedIb === null ||
                                (selectedIb !== null &&
                                selectedIb?.selectedRows?.length === 0) ||
                                (selectedIb !== null &&
                                selectedIb.ib_number === undefined)) && (
                                <>
                                <Col className="text-center text-md-center">
                                    <Alert variant={"info"} style={{ margin: "15px" }}>
                                    Selecciona un Afiliado Comercial para{" "}
                                    <b>
                                        subir su reporte de un més específico
                                    </b>
                                    </Alert>
                                </Col>
                                </>
                            )}
                            {(selectedIb !== null ||
                                (selectedIb !== null &&
                                selectedIb?.selectedRows?.length > 0) ||
                                (selectedIb !== null &&
                                selectedIb.ib_number !== undefined)) && (
                                <>
                                <Col className="text-center">
                                    <h4>
                                    {" "}
                                    <b>
                                        Subir reporte de mes de Afiliado Comercial{" "}
                                        <FontAwesomeIcon icon={faFilePdf} />
                                    </b>
                                    </h4>
                                </Col>
                                </>
                            )}
                            </Row>
                        </Card.Header>
                    </Card>
                </Col>

            </Row>
        </>
    )
}

export default PermissionsAndReportPage;
